import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  getAuthStatus,
  AuthStatus,
  loginRequest,
} from "../../redux/reducers/auth";
import LoginPage from "./LoginPage";

const LoginPageContainer: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [isError, setIsError] = useState<boolean>(false);

  const authStatus = useAppSelector(getAuthStatus);
  const dispatch = useAppDispatch();

  const handleSubmit = () => {
    if (!email || !password) {
      setIsError(true);
    }

    dispatch(loginRequest({ email: email, password: password })).then(
      (resp) => {
        if (resp.payload == null) {
          setIsError(true);
        }
      }
    );
  };

  if (authStatus === AuthStatus.Authenticated) {
    return <Navigate to="/mypage" replace />;
  } else {
    return (
      <LoginPage
        isError={isError}
        handleSubmit={handleSubmit}
        handleEmail={setEmail}
        handlePassword={setPassword}
      />
    );
  }
};

export default LoginPageContainer;
